import { createSelector } from '@reduxjs/toolkit';

export const selectChatbotProps = createSelector(
  [
    state => state.chatbotVisibility.isVisible,
    state => state.chatbotVisibility.animTransition,
    state => state.chatbotVisibility.isPopupMessageVisible,
    state => state.chatbotDetails.settings,
    state => state.chatbotDetails.company,
    state => state.chatbotDetails.logo,
    state => state.chatbotDetails.loading,
    state => state.chatbotDetails.isDirectLink,
    state => state.chatbotDetails.isInactive,
    state => state.chatbotDetails.hasNoBlocks,
  ],
  (
    isChatbotVisible,
    animTransition,
    isPopupMessageVisible,
    settings,
    company,
    logo,
    loading,
    isDirectLink,
    isInactive,
    hasNoBlocks
  ) => ({
    isChatbotVisible,
    animTransition,
    isPopupMessageVisible,
    settings,
    company,
    logo,
    loading,
    isDirectLink,
    isInactive,
    hasNoBlocks,
  })
);
